<template>
  <div class="preorder-stores-popup-component">
    <VButton
        v-if="hasStores"
        :id="uid"
        theme="link"
        @click="visible = true"
    >
      Пункты маршрута
      <VIcon material="keyboard_arrow_down"/>
    </VButton>

    <VPopup
        class="preorder-stores-popup"
        position="bottom"
        align="left"
        :target="'#' + uid"
        :visible="visible"
        :offset="3"
				@update:visible="() => { visible = false }"
    >
      <article
          v-if="hasSellerStore"
          class="store-wrap"
      >
        <header>Пункт отправки</header>
        <div>{{ sellerStore.address.stringRepresentation }}</div>
      </article>

      <article
          v-if="hasBuyerStore"
          class="store-wrap"
      >
        <header>Пункт прибытия</header>
        <div>{{ buyerStore.address.stringRepresentation }}</div>
      </article>

      <footer v-if="deliveryDays">
        Дней доставки: {{ deliveryDays }} {{ Utils.regional.ru.pluralize(deliveryDays, 'день', 'дня', 'дней') }}
      </footer>
    </VPopup>
  </div>
</template>


<script>
import Utils         from '@/core/utils/Utils';
import uniqueIdMixin from '@/lib/mixins/component-unique-id';

export default {
  name:  'VPreorderStoresPopup',

	mixins: [uniqueIdMixin],

  props: {
    sellerStore:  {
      type:    Object,
      default: null,
    },
    buyerStore:   {
      type:    Object,
      default: null,
    },
    deliveryDays: {
      type:    Number,
      default: null,
    },
  },
  data() {
    return {
      Utils,
      visible: false,
    };
  },
  computed: {
    hasSellerStore() {
      return this.$core.utils.isObject(this.sellerStore);
    },
    hasBuyerStore() {
      return this.$core.utils.isObject(this.buyerStore);
    },
    hasStores() {
      return this.hasSellerStore && this.hasBuyerStore;
    },
    target() {
      return this.$el;
    },
  },
};
</script>

<style lang="scss" src="./VPreorderStoresPopup.scss"/>
